// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"71feb3d978808ddfea80","339":"dd38ab65d5974f7899ac"}[chunkId] + ".js";
};